import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlobDisplayComponent } from './blob-display/blob-display.component';
import { BlobListViewComponent } from './blob-list-view/blob-list-view.component';
import { RouterModule } from '@angular/router';
import { MyCustomMaterialModule } from 'san-common';

@NgModule({
  declarations: [BlobDisplayComponent, BlobListViewComponent],
  imports: [
    CommonModule,RouterModule,MyCustomMaterialModule
  ],
  exports: [BlobDisplayComponent, BlobListViewComponent]
})
export class BlobSharedModule { }
